import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'
import { createParagraphsFromText } from '~publish/legacy/editor/nodes'
import { GenerateContentElement } from '~publish/legacy/editor/plugins/generate-content/nodes/GenerateContentElement'

import { getGeneratedText } from '../api/getGeneratedText'

type TGenerateTextParams = {
  editor: BufferEditor
  organizationId: string
  action: string
  service?: string
  annotation: string | null
  metadata: {
    placement: string
    retry: boolean
  }
}

export async function generateText({
  editor,
  organizationId,
  action,
  service,
  annotation,
  metadata,
}: TGenerateTextParams): Promise<void> {
  const { prompt, isHighlighted } = editor.prompt?.() || {}
  const generatedContent = editor.getGeneratedContent?.()

  if (!prompt) {
    throw new Error('Prompt cannot be empty')
  }

  let fullPrompt = prompt
  if (annotation) {
    fullPrompt = fullPrompt.concat(`. ${annotation}`)
  }

  await getGeneratedText({
    organizationId,
    prompt: fullPrompt,
    previousGeneration: generatedContent,
    isHighlighted: isHighlighted ?? false,
    action,
    service,
    metadata,
  })
    .then((response) => {
      const suggestion = editor.api.node({
        at: [],
        match: (n) => GenerateContentElement.is(n),
      })

      if (suggestion) {
        editor.tf.removeNodes({
          at: suggestion[1],
        })
      }

      const paragraphs = createParagraphsFromText(response)
      const position = suggestion?.[1] ?? [editor.children.length]

      editor.tf.insertNodes(
        { type: 'generate-content-element', children: paragraphs },
        { at: position },
      )

      editor.hasGeneratedContent = true

      return true
    })
    .catch((errorMessage) => {
      throw new Error(errorMessage.message)
    })
}
